import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withDisabledInitialNavigation} from '@angular/router';
import {routes} from './app.routes';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';
import {environment} from '../environments/environment';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authInterceptor} from './core/interceptors/auth.interceptor';
import {DialogService} from 'primeng/dynamicdialog';
import {provideServiceWorker} from '@angular/service-worker';
import {MessageService} from 'primeng/api';
import {errorInterceptor} from './core/interceptors/error.interceptor';
import {GlobalErrorHandler} from './core/services/global-error.service';
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
import {retryInterceptor} from './core/interceptors/retry.interceptor';
import {AuthSessionState} from './core/auth/auth-session.state';

registerLocaleData(localeEs, 'es-MX');
export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => inject(AuthSessionState).initialize()),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        retryInterceptor,
        errorInterceptor

      ])
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withDisabledInitialNavigation()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    provideAnimations(),
    DialogService,
    provideServiceWorker('ngsw-worker.js', {
            enabled: environment.enablePWA,
            registrationStrategy: 'registerImmediately'
    }),
    MessageService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    { provide: LOCALE_ID, useValue: 'es-MX' }
  ]
};
